<template>
  <v-row>

    <v-col cols="12" :sm="qrAfip && item.Estado == 'FACTURADO' ? '6' : '12'">
      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="item.Estado" :label="$t('afip.factura.labels.Estado')" icon="view_stream"/>
            <show-field :value="item.CuitEmisor" :label="$t('afip.factura.labels.CuitEmisor')" icon="badge"/>
            <v-alert v-if="item.Error" type="error">
              {{ item.Error }}
            </v-alert>
            <show-field v-if="item.VoucherNumber" :value="item.VoucherNumber"
                        :label="$t('afip.factura.labels.VoucherNumber')" icon="tag"/>
            <show-field v-if="item.CAE" :value="item.CAE" :label="$t('afip.factura.labels.CAE')" icon="fingerprint"/>
            <show-field v-if="item.CAEFchVto" :value="item.CAEFchVto" :label="$t('afip.factura.labels.CAEFchVto')"
                        icon="event"/>

          </v-list>

        </v-card-text>
      </v-card>
    </v-col>

    <v-col v-if="qrAfip && item.Estado == 'FACTURADO'" cols="12" sm="6">
      <v-card class="my-0">
        <v-card-text class="text-center">
          <img :src="qrAfip.imageData"/>
        </v-card-text>
        <v-card-actions>
          <v-btn target="_blank" :href="qrAfip.url">QR LINK</v-btn>
          <v-spacer></v-spacer>
          <v-btn target="_blank" :href="ticketFactura">Ticket</v-btn>
          <v-spacer></v-spacer>
          <v-btn target="_blank" :href="facturaPdf">Factura</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>


    <!--<v-col cols="12" sm="6">

      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="String(item.CantReg)" :label="$t('afip.factura.labels.CantReg')" icon="description"/>
            <show-field :value="String(item.CbteDesde)" :label="$t('afip.factura.labels.CbteDesde')"
                        icon="description"/>
            <show-field :value="String(item.CbteHasta)" :label="$t('afip.factura.labels.CbteHasta')"
                        icon="description"/>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>-->

    <v-col cols="12" sm="6">
      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="String(item.PtoVta)" :label="$t('afip.factura.labels.PtoVta')" icon="description"/>
            <show-field :value="getTipoComprobante(item.CbteTipo)" :label="$t('afip.factura.labels.CbteTipo')"
                        icon="description"/>
            <show-field :value="getTipoConcepto(item.Concepto)" :label="$t('afip.factura.labels.Concepto')"
                        icon="description"/>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>


    <v-col cols="12" sm="6">
      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="getDateFormat(item.FchServDesde)" :label="$t('afip.factura.labels.FchServDesde')"
                        icon="event"/>
            <show-field :value="getDateFormat(item.FchServHasta)" :label="$t('afip.factura.labels.FchServHasta')"
                        icon="event"/>
            <show-field :value="getDateFormat(item.FchVtoPago)" :label="$t('afip.factura.labels.FchVtoPago')"
                        icon="event"/>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6">
      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="String(item.ImpNeto)" :label="$t('afip.factura.labels.ImpNeto')" icon="paid"/>
            <show-field :value="String(item.ImpIVA)" :label="$t('afip.factura.labels.ImpIVA')" icon="paid"/>
            <show-field :value="String(item.ImpTotal)" :label="$t('afip.factura.labels.ImpTotal')" icon="paid"/>

          </v-list>

        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6">
      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="String(item.ImpTrib)" :label="$t('afip.factura.labels.ImpTrib')" icon="paid"/>
            <show-field :value="String(item.ImpOpEx)" :label="$t('afip.factura.labels.ImpOpEx')" icon="paid"/>
            <show-field :value="String(item.ImpTotConc)" :label="$t('afip.factura.labels.ImpTotConc')" icon="paid"/>

          </v-list>

        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6">
      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="String(item.DocTipo)" :label="$t('afip.factura.labels.DocTipo')" icon="description"/>
            <show-field :value="String(item.DocNro)" :label="$t('afip.factura.labels.DocNro')" icon="description"/>
            <show-field :value="getDateFormat(item.CbteFch)" :label="$t('afip.factura.labels.CbteFch')"
                        icon="description"/>

          </v-list>

        </v-card-text>
      </v-card>
    </v-col>


    <v-col cols="12" sm="6">
      <v-card class="my-0">
        <v-card-text>
          <v-list>
            <show-field :value="item.MonId" :label="$t('afip.factura.labels.MonId')" icon="money"/>
            <show-field :value="String(item.MonCotiz)" :label="$t('afip.factura.labels.MonCotiz')" icon="money"/>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>


  </v-row>
</template>
<script>
import {ShowField} from '@dracul/common-frontend'
import {DayjsMixin} from '@dracul/dayjs-frontend'
import AfipProvider from "@/modules/afip/providers/AfipProvider";


export default {
  name: 'FacturaShowData',
  components: {ShowField},
  mixins: [DayjsMixin],
  props: {
    item: {type: Object, required: true}
  },
  data() {
    return {
      qrAfip: null,
      facturaPdf: null,
      ticketFactura: null,
      serverStatus: null,
      puntosVenta: [],
      tiposComprobantes: [],
      tiposConceptos: [],
      tiposDocumentos: []
    }
  },
  computed: {
    getTipoComprobante() {
      return val => {
        let item = this.tiposComprobantes.find(i => i.Id === val)
        return item ? item.Desc : val.toString()
      }
    },
    getTipoConcepto() {
      return val => {
        let item = this.tiposConceptos.find(i => i.Id === val)
        return item ? item.Desc : val.toString()
      }
    },
  },
  created() {
    this.getTipoComprobantes()
    this.getTipoConceptos()
    this.getQrAfip()
    this.getFacturaPdf()
    this.getTicketFactura()
  },
  methods: {
    getFacturaPdf() {
      if (this.item.Estado == 'FACTURADO') {
        AfipProvider.getFacturaPdf(this.item.id)
            .then(r => {
              this.facturaPdf = r.data.getFacturaPdf
            })
      }
    },
    getTicketFactura() {
      if (this.item.Estado == 'FACTURADO') {
        AfipProvider.getTicketFactura(this.item.id)
            .then(r => {
              this.ticketFactura = r.data.getTicketFactura
            })
      }
    },
    getQrAfip() {
      if (this.item.Estado == 'FACTURADO') {
        AfipProvider.getQrAfip(this.item.id)
            .then(r => {
              this.qrAfip = r.data.getQrAfip
            })
      }
    },
    getServerStatus() {
      AfipProvider.getServerStatus()
          .then(r => {
            this.serverStatus = r.data.getServerStatus
          })
    },
    getPuntosVenta() {
      AfipProvider.getPuntosVenta()
          .then(r => {
            this.puntosVenta = r.data.getPuntosVenta
          })
    },
    getTipoComprobantes() {
      AfipProvider.getTipoComprobantes()
          .then(r => {
            this.tiposComprobantes = r.data.getTipoComprobantes
          })
    },
    getTipoConceptos() {
      AfipProvider.getTipoConceptos()
          .then(r => {
            this.tiposConceptos = r.data.getTipoConceptos
          })
    },
    getTipoDocumentos() {
      AfipProvider.getTipoDocumentos()
          .then(r => {
            this.tiposDocumentos = r.data.getTipoDocumentos
          })
    }
  }
}
</script>

